import { faThumbtack, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Switch } from "@progress/kendo-react-inputs";
import axios from "axios";
import * as React from "react";
import { dateFormatter, history, successToastr } from "../../../HelperMethods";
import Skeleton from "react-loading-skeleton";
import CompleteSearch from "../../Shared/Search/CompleteSearch";
import { toODataString } from "@progress/kendo-data-query";
import ContentLibraryDataService from "../Services/DataService";
import { KendoFilter, ShimmerEffectTab, leftChivron, rightChivron } from "../../ReusableComponents";
import { ContentLibStatus, ContentType, DocFileType, UserContentLibrary } from "../../Shared/AppConstants";
import { CONTENT_PINNED_SUCCESS_MSG, CONTENT_UNPINNED_SUCCESS_MSG } from "../../Shared/AppMessages";
import DocumentViewer from "../../Shared/DocumentViewer/DocumentViewer";
import BreadCrumbs from "../../Shared/BreadCrumbs/BreadCrumbs";
import Collapsible from "react-collapsible";
import ItemsCarousel from "react-items-carousel";

export interface ViewcontentLibLibraryProps { }
export interface ViewcontentLibLibraryState {
  onFirstLoad: boolean;
  CheckBoxData?: boolean;
  contentData: any;
  showLoader: boolean;
  dataState: any;
  fileType?: any;
  fileUrl?: any;
  userId: any;
  pinChanged: boolean;
  activeItemIndexMyContent?: any;
  activeItemIndexNewContent?: any;
  setInterval?: any;
  noOfCards?: any;
  windowWidth?: any;
  contentArr?: any;
}
export const initialDataState = {
};
class ViewcontentLibLibrary extends React.Component<
  ViewcontentLibLibraryProps,
  ViewcontentLibLibraryState
> {
  private userObj: any = JSON.parse(localStorage.getItem("user"));
  constructor(props: ViewcontentLibLibraryProps) {
    super(props);
    this.state = {
      onFirstLoad: true,
      CheckBoxData: false,
      contentData: [],
      showLoader: true,
      dataState: initialDataState,
      userId: this.userObj.userId,
      pinChanged: false,
      activeItemIndexMyContent: 0,
      activeItemIndexNewContent: 0,
      setInterval: 1000,
      fileUrl: "",
      noOfCards: 5,
      windowWidth: window.innerWidth,
      contentArr:[]
    };
  }

  componentDidMount() {
    // this.getContentLibrary(this.state.dataState);
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }
  componentWillUnmount() {
    window.addEventListener("resize", this.handleResize);
  }

  handleChange = (e, field) => {
    var stateObj = {};
    stateObj[field] =
      e.target.type == "checkbox" ? e.target.checked : e.target.value;
    this.setState(stateObj);
  };

  getContentLibrary = (dataState) => {
    const { skip, take, ...modifiedDataState } = dataState;
    this.setState({ showLoader: true, onFirstLoad: false });
    var queryStr = `${toODataString(modifiedDataState, { utcDates: true })}`;
    let queryParams = `(statusIntId eq ${ContentLibStatus.PUBLISHED})`;
    var finalQueryString = KendoFilter(modifiedDataState, queryStr, queryParams);
    ContentLibraryDataService.getContentLibraryView(finalQueryString).then((res) => {
      this.setState({
        contentData: res.data,
        showLoader: false,
        dataState: dataState,
      });
    });
  }

  fileIcon = (fileType) => {
    var icon = "";
    var iconColor = "";
    switch (fileType) {
      case DocFileType.WORD:
        icon = "fas fa-file-word"
        iconColor = "#0045A6"
        break;
      case DocFileType.WORD_DOC:
        icon = "fas fa-file-word"
        iconColor = "#0045A6"
        break;
      case DocFileType.WORD_DOCX:
        icon = "fas fa-file-word"
        iconColor = "#0045A6"
        break;
      case DocFileType.VIDEO:
        icon = "fas fa-video"
        iconColor = "#5BC0F8"
        break;
      case DocFileType.VIDEO_MKV:
        icon = "fas fa-video"
        iconColor = "#5BC0F8"
        break;
      case DocFileType.PDF:
        icon = "fas fa-file-pdf"
        iconColor = "#AE030D"
        break;
      case DocFileType.EXCEL:
        icon = "fas fa-file-excel"
        iconColor = "#1C6C40"
        break;
      case DocFileType.EXCEL_XLS:
        icon = "fas fa-file-excel"
        iconColor = "#1C6C40"
        break;
      case DocFileType.EXCEL_XLSX:
        icon = "fas fa-file-excel"
        iconColor = "#1C6C40"
        break;
      case DocFileType.IMAGE_PNG:
        icon = "fas fa-image"
        iconColor = "#28AAE5"
        break;
      case DocFileType.IMAGE_JPEG:
        icon = "fas fa-image"
        iconColor = "#28AAE5"
        break;
      case DocFileType.IMAGE_JPG:
        icon = "fas fa-image"
        iconColor = "#28AAE5"
        break;
      default:
        icon = "fas fa-file"
        iconColor = "#5BC0F8"
        break;
    }
    return { icon, iconColor };
  };

  cardTextColor = (contentType) => {
    var textColor = "";
    var textBgColor = "";
    switch (contentType) {
      case ContentType.BLOG:
        textColor = "#109dd2"
        textBgColor = "#def0fa"
        break;
      case ContentType.TRAININGVIDEOS:
        textColor = "#285430"
        textBgColor = "#def0fa"
        break;
      case ContentType.RELEASENOTES:
        textColor = "#FF8B13"
        textBgColor = "#fcebdb"
        break;
      case ContentType.USERGUIDE:
        textColor = "#3D1766"
        textBgColor = "#dadded"
        break;
      default:
        textColor = "#3D1766"
        textBgColor = "#dadded"
        break;
    }
    return { textColor, textBgColor };
  };

  groupIcon = (notes) => {
    var icon = "";
    switch (notes) {
      case ContentType.BLOG:
        icon = "fas fa-blog"
        break;
      case ContentType.TRAININGVIDEOS:
        icon = "fas fa-video"
        break;
      case ContentType.RELEASENOTES:
        icon = "fa fa-sticky-note-o"
        break;
      case ContentType.USERGUIDE:
        icon = "fas fa-book"
        break;
      default:
        icon = "fas fa-book"
        break;
    }
    return { icon };
  };

  innerGroupIcon = (fileType) => {
    var cardIcon = "";
    var cardIconColor = "";
    switch (fileType) {
      case DocFileType.WORD:
        cardIcon = "fas fa-file-word"
        cardIconColor = "#0045A6"
        break;
      case DocFileType.WORD_DOC:
        cardIcon = "fas fa-file-word"
        cardIconColor = "#0045A6"
        break;
      case DocFileType.WORD_DOCX:
        cardIcon = "fas fa-file-word"
        cardIconColor = "#0045A6"
        break;
      case DocFileType.VIDEO:
        cardIcon = "fas fa-video"
        cardIconColor = "#5BC0F8"
        break;
      case DocFileType.VIDEO_MKV:
        cardIcon = "fas fa-video"
        cardIconColor = "#5BC0F8"
        break;
      case DocFileType.PDF:
        cardIcon = "fas fa-file-pdf"
        cardIconColor = "#AE030D"
        break;
      case DocFileType.EXCEL:
        cardIcon = "fas fa-file-excel"
        cardIconColor = "#1C6C40"
        break;
      case DocFileType.EXCEL_XLS:
        cardIcon = "fas fa-file-excel"
        cardIconColor = "#1C6C40"
        break;
      case DocFileType.EXCEL_XLSX:
        cardIcon = "fas fa-file-excel"
        cardIconColor = "#1C6C40"
        break;
      case DocFileType.IMAGE_PNG:
        cardIcon = "fas fa-image"
        cardIconColor = "#28AAE5"
        break;
      case DocFileType.IMAGE_JPEG:
        cardIcon = "fas fa-image"
        cardIconColor = "#28AAE5"
        break;
      case DocFileType.IMAGE_JPG:
        cardIcon = "fas fa-image"
        cardIconColor = "#28AAE5"
        break;
      default:
        cardIcon = "fas fa-file"
        cardIconColor = "#5BC0F8"
        break;
    }
    return { cardIcon, cardIconColor };
  };

  downloadFile = (filePath, fileName, url, id, content) => {
    this.setState({ fileUrl: "" });
    if ((filePath === "" || fileName === "") && url != undefined) {
      this.handleUrlClick(url);
    } else {
      axios
        .get(`/api/home/documenturl?fileName=${filePath}`)
        .then((res: any) => {
          if (res) {
            console.log(res.data);
            const fileExt = filePath.split('.').pop().toLowerCase();
            let fileType;
            if (fileExt == 'jpg' || fileExt == 'png' || fileExt == 'jpeg') {
              fileType = 'image';
            }
            else if (fileExt == 'pdf') {
              fileType = 'pdf'
            }
            else if (fileExt == 'docx') {
              fileType = 'word'
            }
            else if (fileExt == 'xlsx') {
              fileType = 'excel'
            }
            else if (fileExt == 'mp4') {
              fileType = 'video'
            }
            else {
              fileType = "document"
            }
            this.setState({ fileUrl: res.data, fileType: fileType });
            this.updatedContents(res.data, fileType, id, content);
          }
        })
    }
  };

   updatedContents = (fileUrl, fileType, id, content) => {
    const updatedContent = { ...content, fileUrl: fileUrl, fileType: fileType };
  
    if (fileUrl != "" && fileUrl != undefined && fileUrl != null) {
      if (!this.state.contentArr.some(existingContent => existingContent.id === id)) {
        this.setState(prevState => ({
          contentArr: [...prevState.contentArr, updatedContent],
        }));
      }
    } else if (fileUrl === "" || fileUrl === undefined || fileUrl === null) {
      this.setState(prevState => ({
        contentArr: prevState.contentArr.filter(existingContent => existingContent.id !== id),
      }));
    }
  };

  contentPinned = (content) => {
    content.isPinned = !content.isPinned;
    this.setState({
      pinChanged: !this.state.pinChanged
    })
    const data = {
      contentLibId: content.id,
      userId: this.state.userId,
      isPinned: content.isPinned
    };
    ContentLibraryDataService.patchContentPin(data).then((res) => {
      successToastr(content.isPinned ? CONTENT_PINNED_SUCCESS_MSG : CONTENT_UNPINNED_SUCCESS_MSG);
    });
  };
  updatefileUrlState = (fileUrl) => {
    this.setState({
      fileUrl: fileUrl
    })
  };

  handleUrlClick = (url) => {
    window.open(url)
  };

  newAndMyContentView = (contentData, contentName, openedSection) => {
    return (
      <div>
        {contentData.length > 0 &&
          <Collapsible
            trigger={contentName}
            open={contentName === openedSection ? true : false}
            accordionPosition="1"
          >
            <ItemsCarousel
              placeholderItem={
                ShimmerEffectTab()
              }
              infiniteLoop={this.state.noOfCards < contentData.length ? true : false}
              enablePlaceholder={true}
              numberOfPlaceholderItems={6}
              minimumPlaceholderTime={1000}
              numberOfCards={this.state.noOfCards}
              gutter={10}
              showSlither={true}
              firstAndLastGutter={true}
              freeScrolling={true}
              requestToChangeActive={(e) => {
                contentName === UserContentLibrary.MYCONTENT ? this.setState({ activeItemIndexMyContent: e, setInterval: 10000 }) : this.setState({ activeItemIndexNewContent: e, setInterval: 10000 })
              }}
              activeItemIndex={contentName === UserContentLibrary.MYCONTENT ? this.state.activeItemIndexMyContent : this.state.activeItemIndexNewContent}
              activePosition={"left"}
              chevronWidth={20}
              rightChevron={rightChivron()}
              leftChevron={leftChivron()}
              outsideChevron={false}
              name={contentName}
            >
              {contentData.map((i, index) => {
                let innerGroupIcon = this.innerGroupIcon(i.fileType);
                let fileIcon = this.fileIcon(i.fileType);
                let cardTextColor = this.cardTextColor(i.contentType);
                return (
                  <div
                    className="row ml-mr mx-0"
                    key={i.id}
                  >
                    <div className="col-12 px-0">
                      <div className="card-body shadow-sm contentLib_border d-flex flex-column">
                        <div className="d-flex align-items-start justify-content-between">
                          <div className="d-flex align-items-start">
                            <i
                              className={innerGroupIcon.cardIcon}
                              style={{
                                color: innerGroupIcon.cardIconColor,
                                fontSize: "25px",
                              }}
                            ></i>
                            <div className="pl-3">
                              <h5
                                className="card-text mt-0"
                                style={{
                                  textDecoration: "underline",
                                  fontWeight: "bold",
                                  fontFamily: " 'Noto Sans', sans-serif",
                                  fontSize: "14px",
                                  overflow: "hidden",
                                  textOverflow: "clip",
                                  display: "block",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  cursor: "pointer"
                                }}
                                onClick={() => this.downloadFile(i.path, i.fileName, i.url, i.id, i)}
                              >
                                {i.title}
                              </h5>
                              <p
                                className="card-btn-style mt-0 mx-0"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                  fontFamily: " 'Noto Sans', sans-serif",
                                  color: `${cardTextColor.textColor}`,
                                  backgroundColor: `${cardTextColor.textBgColor}`,
                                }}
                              >
                                {i.contentType}
                              </p>
                            </div>
                          </div>
                          <FontAwesomeIcon
                            icon={faThumbtack}
                            color={i.isPinned ? "black" : "gray"}
                            className={i.isPinned ? "black_rotate" : "gray_rotate"}
                            onClick={() => {
                              this.contentPinned(i)
                            }
                            }
                          />
                        </div>
                        <p
                          className="contentLib_Desc"
                          style={{
                            position: "relative",
                            top: "11px"
                          }}
                          title={i.description}
                        >
                          {i.description.length < 49 ? i.description.slice(0, 49) : <>{i.description.slice(0, 49)}...</>}
                        </p>
                        <div>
                          {<span style={{ fontSize: '11px' }}>Published Date : {i.publishedDate != null ? `${dateFormatter(new Date(i.publishedDate))}` : "-"}</span>}
                        </div>
                        <div className="mt-3" style={{ display: 'flex' }}>
                          {i.isFeatured && <span className="badge text-white" style={{ margin: '0 5px 0 0', backgroundColor: 'rgb(6 114 173)' }}>Featured</span>}
                          {i.isNewContent && <span className="badge badge-danger" style={{ margin: '0 5px' }}>New</span>}
                        </div>
                        <div className="d-flex mt-2">
                          {i.url && <div className="fw-semibold url-wrap" style={{ display: 'flex', fontSize: '11px' }}>URL:
                            <a style={{ color: '#000', textDecoration: "underline", cursor: "pointer" }} title={i.url} className="cardUrl ml-2" onClick={() => this.handleUrlClick(i.url)}>
                              {i.url}
                            </a></div>}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </ItemsCarousel>
          </Collapsible>
        }
      </div>)
  }

  categorisedContentView = (contentData, openedSection) => {
    return (
      <div>
        {contentData.length > 0 ?
          <Collapsible
            trigger={contentData[0].contentType}
            open={contentData[0].contentType === openedSection ? true : false}
            accordionPosition="1"
          >
            <div className="col-12 contentLib_title mb-2 mt-4">
            </div>
            <div className="col-12">
              <div className="row">
                {contentData
                  .filter((x) => !x.isPinned)
                  .map((i) => {
                    let innerGroupIcon = this.innerGroupIcon(i.fileType);
                    return (
                      <div
                        className="col-sm-6 col-md-4 col-lg-3 px-1 contentLib_custome_card mb-3"
                        key={i.id}
                      >
                        <div className="card-body shadow-sm contentLib_border d-flex flex-column">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                              <i
                                className={innerGroupIcon.cardIcon}
                                style={{
                                  color: innerGroupIcon.cardIconColor,
                                  fontSize: "25px",
                                }}
                              ></i>
                              <h5
                                className="card-text mt-0 ml-3"
                                style={{
                                  textDecoration: "underline",
                                  fontWeight: "bold",
                                  fontFamily: " 'Noto Sans', sans-serif",
                                  fontSize: "14px",
                                  overflow: "hidden",
                                  textOverflow: "clip",
                                  display: "block",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  cursor: "pointer"
                                }}
                                onClick={() => this.downloadFile(i.path, i.fileName, i.url, i.id, i)}
                              >
                                {i.title}
                              </h5>
                            </div>
                            <div>
                              <FontAwesomeIcon
                                icon={faThumbtack}
                                color={i.isPinned ? "black" : "gray"}
                                className={i.isPinned ? "black_rotate" : "gray_rotate"}
                                onClick={() =>
                                  this.contentPinned(i)
                                }
                              />
                            </div>
                          </div>
                          <p
                            className="contentLib_Desc"
                            style={{
                              position: "relative",
                              top: "11px",
                            }}
                            title={i.description}
                          >
                            {i.description.length < 49 ? i.description.slice(0, 49) : <>{i.description.slice(0, 49)}...</>}
                          </p>
                          <div>
                            {<span style={{ fontSize: '11px' }}>Published Date : {i.publishedDate != null ? `${dateFormatter(new Date(i.publishedDate))}` : "-"}</span>}
                          </div>
                          <div className="mt-3" style={{ display: 'flex' }}>
                            {i.isFeatured && <span className="badge text-white" style={{ margin: '0 5px 0 0', backgroundColor: 'rgb(6 114 173)' }}>Featured</span>}
                            {i.isNewContent && <span className="badge badge-danger" style={{ margin: '0 5px' }}>New</span>}
                          </div>
                          <div className="d-flex mt-2">
                            {i.url && <div className="fw-semibold" style={{ display: 'flex', fontSize: '11px' }}>URL:
                              <a style={{ color: '#000', textDecoration: "underline", cursor: "pointer" }} title={i.url} className="cardUrl ml-2" onClick={() => this.handleUrlClick(i.url)}>
                                {i.url}
                              </a></div>}
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </Collapsible> : <></>}
      </div>
    )
  }
  handleResize = () => {
    this.setState({ windowWidth: window.innerWidth }, () =>
      this.state.windowWidth < 500
        ? this.setState({ noOfCards: 1 })
        : this.state.windowWidth > 500 && this.state.windowWidth < 992 ?
          this.setState({ noOfCards: 3 }) : this.setState({ noOfCards: 5 })
    );
  };

  render() {
    const element = this.state.CheckBoxData;
    const notes = [];
    const myContent = [];
    const newContent = [];
    const categorisedContent = [];

    this.state.contentData.forEach((item) => {
      if (!notes.some((note) => note.notes === item.contentType)) {
        notes.push({ notes: item.contentType });
      }
      if (item.isPinned) {
        myContent.push(item);
      } else if (item.isNewContent || item.isFeatured) {
        newContent.push(item);
      }
      if (!item.isPinned) {
        const index = notes.findIndex((note) => note.notes === item.contentType);
        if (index !== -1) {
          if (!categorisedContent[index]) {
            categorisedContent[index] = [];
          }
          categorisedContent[index].push(item);
        }
      }
    });
    categorisedContent.sort((a, b) => {
      const noteA = a[0].contentType.toLowerCase();
      const noteB = b[0].contentType.toLowerCase();
      return noteA.localeCompare(noteB);
    });
    let openedSection = ""
    if (myContent.length > 0) {
      openedSection = UserContentLibrary.MYCONTENT;
    } else if (newContent.length > 0) {
      openedSection = UserContentLibrary.NEWANDFEATUREDCONTENT;
    } else if (categorisedContent.length > 0) {
      for (let i = 0; i < categorisedContent.length; i++) {
        if (categorisedContent[i].length > 0) {
          openedSection = categorisedContent[i][0].contentType;
          break;
        }
      }
    }
    return (
      <div className="col-11 mx-auto pl-0 pr-0 mt-3 mt-md-0">
        {/* {this.state.fileUrl && (<DocumentViewer fileType={this.state.fileType} fileUrl={this.state.fileUrl} updatefileUrlState={this.updatefileUrlState} />)} */}
        <div className="container-fluid mt-3 mb-4 d-md-block d-none">
          <div className="row pt-2 pb-2 mt-3 accordianTitleClr mx-auto mb-2">
            <div className="col-10 fonFifteen paddingLeftandRight">
              <BreadCrumbs></BreadCrumbs>
            </div>
            <div className="col-2">
              <span className="float-right text-dark">
                <div>
                  <Switch
                    onLabel={""}
                    offLabel={""}
                    checked={this.state.CheckBoxData}
                    onChange={(e) => this.handleChange(e, "CheckBoxData")}
                  />
                </div>
              </span>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <CompleteSearch
            page="ViewContentLibrary"
            entityType={"Content Library"}
            placeholder="Search text here!"
            handleSearch={this.getContentLibrary}
            onFirstLoad={this.state.onFirstLoad}
            persistSearchData={true}
          />
          {this.state.showLoader &&
            Array.from({ length: 4 }).map((item, i) => (
              <div className="row mx-auto mt-2" key={i}>
                {Array.from({ length: 3 }).map((item, j) => (
                  <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1" key={j}>
                    <Skeleton width={50} />
                    <Skeleton height={100} />
                  </div>
                ))}
              </div>
            ))} <div className="row ">
            <div className="col-12">
              {this.newAndMyContentView(myContent, UserContentLibrary.MYCONTENT, openedSection)}
              {this.newAndMyContentView(newContent, UserContentLibrary.NEWANDFEATUREDCONTENT, openedSection)}
            </div>
          </div>
          {!this.state.showLoader &&
            <div className="row ">
              {this.state.contentData.length > 0 ? (
                <>
                  {element
                    ?
                    <div className="col-12">
                      <Collapsible
                        trigger={"All Content"}
                        open={openedSection !== UserContentLibrary.MYCONTENT && openedSection !== UserContentLibrary.NEWANDFEATUREDCONTENT}
                        accordionPosition="1"
                      >
                        <div className="row mx-0">
                          {this.state.contentData.filter(i => !i.isPinned).map((i) => {
                            let fileIcon = this.fileIcon(i.fileType);
                            let cardTextColor = this.cardTextColor(i.contentType);
                            return (
                              <div
                                className="col-sm-6 col-md-4 col-lg-3 px-1 contentLib_custome_card mb-3"
                                key={i.id}
                              >
                                <div className="card-body shadow-sm contentLib_border d-flex flex-column">
                                  <div className="d-flex align-items-start justify-content-start">
                                    <div className=" d-flex align-items-start justify-content-between w-100">
                                      <div className=" d-flex align-items-start">
                                        <div>
                                          <i
                                            className={fileIcon.icon}
                                            style={{ color: fileIcon.iconColor, fontSize: "25px" }}
                                          ></i>
                                        </div>
                                        <div>
                                          <h5
                                            className="card-text mt-0 pl-3"
                                            style={{
                                              textDecoration: "underline",
                                              fontWeight: "bold",
                                              fontFamily: " 'Noto Sans', sans-serif",
                                              fontSize: "15px",
                                              overflow: "hidden",
                                              textOverflow: "clip",
                                              display: "block",
                                              whiteSpace: "normal",
                                              wordBreak: "break-word",
                                              cursor: "pointer"
                                            }}
                                            onClick={() => this.downloadFile(i.path, i.fileName, i.url, i.id, i)}
                                          >
                                            {i.title}
                                          </h5>
                                          <p
                                            className="card-btn-style mt-0 ml-0 mr-0 ml-3"
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "14px",
                                              fontFamily: " 'Noto Sans', sans-serif",
                                              color: `${cardTextColor.textColor}`,
                                              backgroundColor: `${cardTextColor.textBgColor}`,
                                            }}
                                          >
                                            {i.contentType}
                                          </p>
                                        </div>
                                      </div>
                                      <div>
                                        <FontAwesomeIcon
                                          icon={faThumbtack}
                                          color={i.isPinned ? "black" : "gray"}
                                          className={i.isPinned ? "black_rotate" : "gray_rotate"}
                                          onClick={() =>
                                            this.contentPinned(i)
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <p className="contentLib_Desc" title={i.description}>
                                    {i.description.length < 49 ? i.description.slice(0, 49) : <>{i.description.slice(0, 49)}...</>}
                                  </p>
                                  <div>
                                    {<span style={{ fontSize: '11px' }}>Published Date : {i.publishedDate != null ? `${dateFormatter(new Date(i.publishedDate))}` : "-"}</span>}
                                  </div>
                                  <div style={{ display: 'flex' }}>
                                    {i.isFeatured && <span className="badge text-white" style={{ margin: '0 5px 0 0', backgroundColor: 'rgb(6 114 173)' }}>Featured</span>}
                                    {i.isNewContent && <span className="badge badge-danger" style={{ margin: '0 5px' }}>New</span>}
                                  </div>
                                  <div className="d-flex mt-2">
                                    {i.url && <div className="fw-semibold" style={{ display: 'flex', fontSize: '11px' }}>URL:
                                      <a style={{ color: '#000', textDecoration: "underline", cursor: "pointer" }} title={i.url} className="cardUrl ml-2" onClick={() => this.handleUrlClick(i.url)}>
                                        {i.url}
                                      </a></div>}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </Collapsible>
                    </div>
                    :
                    <div className="col-12">
                      {categorisedContent.map((i) => (
                        this.categorisedContentView(i, openedSection)
                      ))}
                    </div>} </>)
                : <div className="col-12 text-center" style={{ fontSize: '13px' }}><p>No records found!</p></div>
              }
              {this.state.contentArr.map((content) => (
                <DocumentViewer
                  key={content.id}
                  content={content}
                  updatedContents={this.updatedContents}
                />
              ))}
            </div>
          }
          <div className="modal-footer justify-content-center border-0">
            <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
              <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={() => history.goBack()}>
                <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ViewcontentLibLibrary;